import { configureStore, combineReducers } from "@reduxjs/toolkit";
import counterReducer from "./features/counterSlice";
import authReducer from "./features/authSlice";
import userReducer from "./features/userSlice"
import authenReducer from "./features/authenSlice"
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import screenshotReducer from "./features/screenshotSlice"
import shortenLinkReducer from "./features/linkSlice"
import accountDetails from "./features/accounts"
import pdfReducer from "./features/pddSlics"
import scrapperReducer from "./features/scrapper"
import folderReducer from "./features/folder"
import orderReducer from "./features/Orders"
import progressReducer from "./features/progressSlice"
import paymentsReducer from "./features/payments"
import plansReducer from "./features/plans"
import apiLogsReducer from "./features/apiLogs"
import internalReducer from "./features//internal"
import seoReducer from "./features/seo"
import usersListReducer from "./features/usersList"
import ecardsReducer from "./features/ecard"
import analyticsReducer from "./features/analytics"
import transferControllerSliceReducer from "./features/transferControllerSlice"
import apiSliceReducer from "./features/apis"
import paymentSliceReducer from "./features/payment"
import complaintsSliceReducer from "./features/complaint"
import affiliatesReducer from "./features/affiliates"
import verifyAccountReducer from './features/verifyAccount'
import invoiceReducer from './features/invoice'
import notificationReducer from './features/notification'
import profileReducer from './features/profile'
import pinReducer from './features/pinSlice'
import notesReducer from './features/stackNotes'
import auditLogsReducer from './features/auditLogs'
import integrateReducer from './features/integrations'

const appReducer = combineReducers({
  counter: counterReducer,
  auth: authReducer,
  user: userReducer,
  authen: authenReducer,
  screenshot: screenshotReducer,
  shortenLink: shortenLinkReducer,
  accounts: accountDetails,
  pdf: pdfReducer,
  scrapper: scrapperReducer,
  folder: folderReducer,
  progress: progressReducer,
  orders: orderReducer,
  payments: paymentsReducer,
  plans: plansReducer,
  apiLogs: apiLogsReducer,
  internal: internalReducer,
  seo: seoReducer,
  usersList: usersListReducer,
  ecards: ecardsReducer,
  analytics: analyticsReducer,
  transferController: transferControllerSliceReducer,
  api: apiSliceReducer,
  subpayment: paymentSliceReducer,
  complaints: complaintsSliceReducer,
  affiliates:affiliatesReducer,
  verifyAccount:verifyAccountReducer,
  invoice:invoiceReducer,
  notification:notificationReducer,
  profile:profileReducer,
  pin:pinReducer,
  notes:notesReducer,
  auditLogs:auditLogsReducer,
  integrate:integrateReducer,

});

const rootReducer = (state, action) => {
  if (action.type === "RESET") {
    state = undefined; 
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export default store;
